import Layout from '@/layout'

const permissionRouter = {
  path: '/user',
  component: Layout,
  redirect: 'noRedirect',
  meta: {
    title: '参赛用户'
  },
  children: [{
    path: 'registration',
    component: () => import('@/views/user/registration'),
    name: 'UserRegistration',
    meta: {
      title: '作品报名',
      icon: 'baoming'
    }
  }, {
    path: 'myProduct',
    component: () => import('@/views/user/myProduct'),
    name: 'UserMyProduct',
    meta: {
      title: '我的作品',
      icon: 'chanpin2'
    }
  },
  // {
  //   path: 'document',
  //   component: () => import('@/views/user/document'),
  //   name: 'UserDocument',
  //   meta: {
  //     title: '相关文档',
  //     icon: 'xinxi'
  //   }
  // },
  {
    path: 'address',
    component: () => import('@/views/user/address'),
    name: 'UserAddress',
    meta: {
      title: '我的信息',
      icon: 'dizhi'
    }
  }, {
    path: 'password',
    component: () => import('@/views/user/password'),
    name: 'UserPassword',
    meta: {
      title: '更改密码',
      icon: 'mima'
    }
  }, {
    path: 'onSiteJudging',
    component: () => import('@/views/user/onSiteJudging'),
    name: 'onSiteJudging',
    meta: {
      title: '复评',
      icon: 'chanpin2'
    }
  }, {
    path: 'winnerService',
    component: () => import('@/views/user/winnerService'),
    name: 'winnerService',
    meta: {
      title: '获奖者服务',
      icon: 'chanpin2'
    }
  }]
}

export default permissionRouter
